import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiNotificationService } from './notification.service';
import { FiNotificationsPullComponent } from './notifications-pull.component';

@NgModule({
    imports: [CommonModule],
    declarations: [FiNotificationsPullComponent],
    providers: [FiNotificationService],
    exports: [FiNotificationsPullComponent],
})
export class FiNotificationModule {}
